var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConcade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6106 12.2359C16.107 12.0076 16.3552 11.8934 16.4276 11.7804C16.5 11.6674 16.5 11.4873 16.5 11.1272V10.8729C16.5 10.5128 16.5 10.3327 16.4276 10.2197C16.3551 10.1066 16.107 9.99251 15.6106 9.76427C14.8747 9.42583 14.402 8.68527 14.4273 7.9103C14.4467 7.31814 14.4563 7.02205 14.3921 6.90949C14.3279 6.79692 14.1724 6.71172 13.8613 6.54132L13.5656 6.37929C13.2641 6.2141 13.1133 6.13151 12.9845 6.13759C12.8557 6.14368 12.6367 6.29211 12.1987 6.58898C11.4864 7.07177 10.5145 7.07175 9.80216 6.58894C9.36415 6.29206 9.14514 6.14363 9.01636 6.13754C8.88757 6.13145 8.73681 6.21405 8.43528 6.37924L8.13953 6.54126C7.82855 6.71164 7.67305 6.79683 7.60883 6.90936C7.54461 7.0219 7.55422 7.31802 7.57344 7.91027C7.59859 8.68529 7.12555 9.42588 6.38939 9.76431C5.89306 9.99247 5.6449 10.1066 5.57245 10.2196C5.5 10.3326 5.5 10.5127 5.5 10.8729V11.1272C5.5 11.4873 5.5 11.6674 5.57243 11.7805C5.64487 11.8935 5.89304 12.0076 6.38938 12.2359C7.12532 12.5743 7.59799 13.3149 7.57267 14.0898C7.55332 14.682 7.54365 14.9781 7.60788 15.0906C7.6721 15.2032 7.82762 15.2884 8.13866 15.4588L8.43441 15.6208C8.73598 15.7861 8.88677 15.8687 9.01558 15.8626C9.14439 15.8565 9.36334 15.708 9.80123 15.4111C10.5141 14.9277 11.4868 14.9277 12.1996 15.411C12.6375 15.708 12.8565 15.8564 12.9853 15.8625C13.1141 15.8686 13.2649 15.786 13.5665 15.6208L13.8622 15.4588C14.1733 15.2883 14.3289 15.2031 14.3931 15.0905C14.4573 14.9779 14.4476 14.6819 14.4281 14.0898C14.4026 13.3149 14.8749 12.5744 15.6106 12.2359Z",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 1.60417,
    stroke: "#2177FE",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 1.83337V4.45373C15.7632 2.83283 13.4983 1.83337 11 1.83337C5.93737 1.83337 1.83331 5.93743 1.83331 11C1.83331 12.3037 2.10547 13.5439 2.59606 14.6667M4.58331 20.1667V17.5464C6.23675 19.1673 8.50165 20.1667 11 20.1667C16.0626 20.1667 20.1666 16.0627 20.1666 11C20.1666 9.69635 19.8945 8.45622 19.4039 7.33337",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcade);
export default __webpack_public_path__ + "static/media/concade.f8ce198c8176aa137bad48e1f09988cc.svg";
export { ForwardRef as ReactComponent };